const selectors = {
  sort: 'data-sort-enabled',
  sortLinks: '[data-sort-link]',
  sortButtonText: '[data-sort-button-text]',
  sortValue: 'data-value',
};

const classes = {
  active: 'popout-list__item--current',
};

class Sort {
  constructor(section) {
    this.container = section.container;
    this.sort = this.container.querySelector(`[${selectors.sort}]`);
    this.sortLinks = this.container.querySelectorAll(selectors.sortLinks);
    this.sortButtonText = this.container.querySelector(selectors.sortButtonText);

    if (this.sort) {
      this.init();
    }
  }

  init() {
    this.sortLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.sortingResults(e);
      });
    });
  }

  sortingResults(e) {
    const link = e.currentTarget;
    const sort = link.getAttribute(selectors.sortValue);
    const text = link.innerText;

    this.sortButtonText.innerText = text;
    this.sortButtonText.parentNode.dispatchEvent(new Event('click'));

    this.sort.querySelector(`.${classes.active}`).classList.remove(classes.active);
    link.parentNode.classList.add(classes.active);

    this.sort.setAttribute(selectors.sort, sort);

    this.container.dispatchEvent(
      new CustomEvent('theme:form:filter', {
        bubbles: true,
        detail: {
          params: sort,
        },
      })
    );
  }
}

export default Sort;
